import ProcessImg from "../../media3/featurePage/Process.png";
import { useNavigate } from "react-router-dom";
function FeatureProcess({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const handleGetStartedClick = () => {
    if (!isLoggedIn) {
      setLoginModalOpen(true);
    } else {
      // User is already logged in, could redirect to inventory or profile
      console.log('User is already logged in!');
    }
  };

  //     const handleExploreClick = () => {
  //   const upcomingSkinsSection = document.getElementById('upcoming-skins');
  //   if (upcomingSkinsSection) {
  //     upcomingSkinsSection.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };
    const navigate = useNavigate();
  return (
    <section className="feature-process-section">
      <div className="feature-process-container">
        <img src={ProcessImg} alt="Process Flow" className="process-bg" />
        <div className="process-header">
          <h1>How It Works</h1>
          <p>
            Use this as a step-by-step flow explaining how users interact with
            SkinForge.
          </p>
          {/* <button className="get-started-btn"  onClick={handleExploreClick}>
            {isLoggedIn ? 'View Inventory' : 'Get Started'}
          </button> */}
          <button
            className="about-btn"
            onClick={() => {
              navigate("/categories");
              window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            }}
          >
            Click Here
          </button>
                  </div>

        {/* Step 1 */}
        <div className="process-step step1">
          <h3>Explore the Collection</h3>
          <p>
            Browse an ever-expanding library of exclusive game skins. Filter by
            rarity, weapon type, or theme — your perfect match is just a click away.
          </p>
        </div>

        {/* Step 2 */}
        <div className="process-step step2">
          <h3>Instant Ownership</h3>
          <p>
            Forget the endless trade queues. Buy and own your favorite skins instantly —
            no waiting, no hidden steps.
          </p>
        </div>

        {/* Step 3 */}
        <div className="process-step step3">
          <h3>Track & Manage</h3>
          <p>
            Keep your inventory organized and up to date with real-time tracking and
            secure storage.
          </p>
        </div>
      </div>
    </section>
  );
}

export default FeatureProcess;
